import rtk /* , { select } */ from 'rtk';
import { createSelectorHooks } from 'rtk/react';
import { name } from './constants';
const { createSelectors } = rtk(name);

const selectors = createSelectors({
  list: [(state) => state[name].uploads, (uploads) => Object.values(uploads)],
  upload: (state, uuid) => state[name].uploads[uuid],
  selected_device_id: (state) => state[name].selectedDeviceId,
});

// RTK-AUTOEXPORT
// ---- selectors ---------
export const { selectList, selectUpload, selectSelectedDeviceId } = selectors;
export const { useList, useUpload, useSelectedDeviceId } =
  createSelectorHooks(selectors);
